import { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config/api";

const AuthContext = createContext();

export function AuthProvider({ children }) {

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true)
    const [errorLogin, setErrorLogin] = useState(null);
    const [score, setScore] = useState(null);
    const navigate = useNavigate()

    useEffect(() => {

        const verificaUsuario = async () => {

            const token = localStorage.getItem("token");

            // Não existe token
            if (!token) {
                setUser(null);
                setLoading(false);
                return;
            }

            try {

                const response = await fetch(
                    `${API_URL}/user/me`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                if (!response.ok) {
                    logout()
                    return;
                }

                const data = await response.json();

                console.log("Usuário recuperado:", data);

                setUser(data);
                setScore(data.score);

            } catch (error) {

                console.error(
                    "Erro ao recuperar usuário:",
                    error
                );

                setUser(null);

            } finally {

                setLoading(false);

            }
        };

        verificaUsuario();

    }, []);

    const login = async (dadosUsuario) => {
        try {
            const response = await fetch(`${API_URL}/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(dadosUsuario)
            });

            if (response.ok) {
                const data = await response.json();
                localStorage.setItem("token", data.token);

                setUser(data.user)
                setScore(data.user.score)
                console.log(data)
                

                return data.user.firstLogin
                
            } else {
                const errorMessage = await response.text();
                console.error("Erro na autenticação:", errorMessage);
                setErrorLogin(errorMessage); 
            }
            } catch (error) {
                alert("Erro de rede ou servidor fora do ar");
        }
    };

    const logout = () => {
        localStorage.removeItem("token");
        setUser(null);
        setScore(0);
        navigate('/login')
    };



    return (
        <AuthContext.Provider value={{
            user,
            login,
            logout,
            loading,
            errorLogin,
            score,
            logout,
            setScore
        }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}